import { ThemedText } from "@/components/themed-text";
import { BrandColors } from "@/constants/theme";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, View } from "react-native";

interface BookingRatingBannerProps {
  rating: number;
}

export const BookingRatingBanner: React.FC<BookingRatingBannerProps> = ({
  rating,
}) => {
  return (
    <View style={styles.banner}>
      <View style={styles.leftContent}>
        <View style={styles.checkCircle}>
          <Ionicons name="checkmark" size={14} color={BrandColors.white} />
        </View>
        <ThemedText style={styles.bannerText} type="smallSemiBold">
          You rated this booking {rating} stars
        </ThemedText>
      </View>

      <View style={styles.starsRow}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Ionicons
            key={index}
            name={index < rating ? "star" : "star-outline"}
            size={18}
            color="#FBBF24"
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: BrandColors.primaryLight,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: BrandColors.primary,
    paddingVertical: 14,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    gap: 12,
  },
  leftContent: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  checkCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: BrandColors.primary,
    alignItems: "center",
    justifyContent: "center",
  },
  bannerText: {
    flex: 1,
    color: BrandColors.primary,
    fontWeight: "600",
    fontSize: 14,
  },
  starsRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  },
});
